import React, { Component } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import { Button, Grid, Row, Col, Glyphicon } from 'react-bootstrap'
import { translate } from '../../../common/utils'
import { createDocument, updateDocument, removeDocument } from '../actions'
import SendSMSDialog from '../../../common/components/SendSMSDialog'
import swal from 'sweetalert2'
import axios from 'axios'
import settings from '../../../settings'
import DriverEventsBox from './DriverEventsBox'

const styles = {
    content: {
        top: '15%',
        left: '5%',
        bottom: '5%',
        right: '5%'
    }
}

class HandleDriverModal extends Component {
    constructor(props) {
        super(props)
        const { driver } = props
        this.state = {
            modalIsOpen: false,
            properties: {
                name: driver.name,
                surname: driver.surname,
                email: driver.email,
                phone: driver.phone,
                area: driver.area
            },
            terminal: driver.terminal
        }
        this.openModal = this.openModal.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.changeField = this.changeField.bind(this)
        this.sendSMS = this.sendSMS.bind(this)
    }

    openModal() {
        this.setState({
            modalIsOpen: true
        })
    }

    closeModal(e) {
        this.props.closeModal()
    }

    changeField(e) {
        var s = Object.assign({}, this.state)
        s.properties[e.target.name] = e.target.value
        this.setState(s)
    }

    save = () => {
        this.props.updateDriver(this.props.driver._id, { ... this.state.properties, _id: this.props.driver._id, terminal: this.state.terminal }).then(this.closeModal).catch(console.log)
    }

    sendSMS() {
        SendSMSDialog(this.props.driver.phone)
    }

    changePassword(e, driver) {
        swal.fire({
            title: 'Fyll i nytt lösenord',
            input: 'text',
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            cancelButtonText: "Avbryt",
            confirmButtonText: 'Spara',
            confirmButtonColor: '#006e78',
            showLoaderOnConfirm: true,
            preConfirm: (password) => {
                return axios
                    .put(`${window.MYQLOCX_API}/subject/${window.localStorage.userType}/drivers/password/${driver._id}`, { password })
                    .then(res => {
                        return res.data
                    })
                    .catch(err => console.log('ERROR:', err.response))
            },
        }).then((result) => {
            swal.fire({
                title: result.value,
                confirmButtonColor: '#006e78'
            })
        })
    }

    removeDriver(e, driver) {
        swal.fire({
            title: 'Är du säkert på att du vill ta bort ' + driver.name + " som chaufför?",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#006e78',
            cancelButtonColor: '#CE4547',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nej!'
        }).then((result) => {
            if (result.value && result.value == true) {
                this.props.removeDriver(driver._id)
                this.closeModal()
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    render() {
        const { terminals, driver } = this.props

        if (!this.props.modalIsOpen) return null

        return (
            <div>
                <Modal
                    ariaHideApp={false}
                    isOpen={this.props.modalIsOpen}
                    onRequestClose={this.closeModal}
                    style={styles}
                    contentLabel="E">
                    <button onClick={this.closeModal}>Stäng</button>

                    <hr />

                    <Grid>
                        <Row>
                            <Col md={6}>
                                <Grid>
                                    {Object.keys(this.state.properties).map((key, i) => {
                                        if (localStorage.userType === 'c_terminal' && key === 'area') return null
                                        return (
                                            <div key={i} style={{ width: '50%' }}>
                                                {/* <p>{translate(key)}:</p> */}
                                                <div className="input-group">
                                                    <div style={{ width: '50%' }}>{translate(key)}:</div> <input
                                                        name={key}
                                                        style={{ width: '100%' }}
                                                        className="change-input form-control"
                                                        value={this.state.properties[key] || ''}
                                                        type="text"
                                                        onKeyPress={this.onKeyDown}
                                                        onChange={this.changeField}
                                                    />
                                                </div>
                                                <br />

                                            </div>
                                        )
                                    })}
                                    {/* TERMINAL HERE */}
                                    {localStorage.userType !== 'c_terminal' && (
                                        <Col>
                                            <Row>
                                                <div className="input-group">
                                                    <p>Åkeri:</p>
                                                    <select style={{ margin: '0 40px' }} onChange={(e) => this.setState({ terminal: e.target.value })} defaultValue={(() => {
                                                        const terminal = terminals.find((t) => t._id === driver.terminal)
                                                        return terminal && terminal._id
                                                    })()}>
                                                        {[{ id: '_', email: 'Välj' }].concat(terminals).map((terminal) => (
                                                            <option key={terminal._id} value={terminal._id}>{terminal.email}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </Row>
                                        </Col>
                                    )}
                                </Grid>
                            </Col>
                            <Col md={1}>
                                <div style={{ marginLeft: 50, border: '1px solid lightgrey', width: '1px', height: '100%' }}>
                                    &nbsp;
                                </div>
                            </Col>
                            <Col md={5}>
                                <Row>
                                    <Col>
                                        <Button className="save-settings-btn" type="submit" onClick={this.sendSMS}>
                                            <Glyphicon glyph="glyphicon glyphicon-send" /> &nbsp; Skicka SMS
                                         </Button>
                                    </Col>
                                </Row>
                                <br />
                                <Row>
                                    <Col>
                                        <Button className="save-settings-btn" type="submit" style={{ width: "100%" }} onClick={(e) => this.changePassword(e, this.props.driver)}>
                                            <Glyphicon glyph="glyphicon glyphicon-cog" /> &nbsp; Ändra lösenord
                                        </Button>
                                    </Col>
                                </Row>
                                <br />
                                <Row>
                                    <Col>
                                        <Button className="smallQbuttonWarning" style={{ width: "100%" }} type="submit" onClick={(e) => this.removeDriver(e, this.props.driver)}>
                                            <Glyphicon glyph="glyphicon glyphicon-remove" /> &nbsp; Ta bort chaufför
                                         </Button>
                                    </Col>
                                </Row>
                                <Row style={{ overflow: 'auto', maxHeight: '350px' }}>
                                    <Col>
                                        {this.props.modalIsOpen && this.props.events ? <DriverEventsBox events={this.props.events.filter(e => e.driver == this.props.driver._id)} /> : null}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <Button className="save-settings-btn" type="submit" onClick={this.save}>
                                    Spara ändringar
                                </Button>
                            </Col>
                        </Row>

                    </Grid>

                </Modal >
            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
    }
}

const mapDispatch = (dispatch) => {
    return {
        removeDriver: (id) => dispatch(removeDocument('driver', id)),
        submitData: (id, obj) => dispatch(createDocument('driver', { id, obj })),
        updateDriver: (id, obj) => dispatch(updateDocument('driver', id, obj))
    }
}

export default connect(mapStateToProps, mapDispatch)(HandleDriverModal)